<template>

  <body class="bg-dark1">
    <div class="portrait-view">
      <div class="portrait-header">
        <div class="d-flex justify-content-between align-items-center h-56">
          <!-- <a href="#" class="brand-logo center t-headline8 t-color-dark  l-spacing6">구매 정보</a> -->
          <div class="d-flex align-items-center">
            <a @click="goBacKPreviousPage" data-target="mobile-demo" class="sidenav-trigger t-color-white mgl-16"><i
                class="material-icons w-22">arrow_back</i></a>
            <div class="t-body6 t-color-white mgl-16 landscape-show">
              {{ lessonName }}
            </div>
          </div>
          <div class="d-flex align-items-baseline justify-content-end">
            <a @click="onLike" data-target="mobile-demo" class="right pdr-16 t-color-gray9 likeVideo"
              :class="likes ? 'active' : ''"><i class="material-icons w-22 h-23">favorite</i></a>
            <a @click="onBookmark" data-target="mobile-demo" class="right pdr-16 t-color-gray9 addBookmark"
              :class="clipping ? 'active' : ''"><i class="material-icons w-22 h-23">bookmark</i></a>
            <!-- <button @click="moveQuestion()" id="btnQnA" class="d-landscape-none"></button>-->
            <a @click="moveQuestion()" data-target="mobile-demo"
              class="right pdr-16 t-color-gray9 hide-landscape-mode"><i
                class="material-icons w-22 h-23">live_help</i></a>
          </div>
        </div>
        <div class="d-flex justify-content-between pdt-8 pdl-16 pdr-16 pdb-10 potrait-show">
          <div class="t-body6 t-color-white">
            {{ lessonName }}
          </div>
          <div class="t-body6 t-color-white">{{ rate }} %</div>
        </div>
        <div class="divider bg-divider"></div>
      </div>

      <div class="content-box content-box-static d-flex align-items-center justify-content-center"
        v-if="staticPageStatus">

      </div>

      <swiper ref="mySwiper" v-if="staticPageStatus"></swiper>

      <div v-if="!staticPageStatus" class="content-box d-flex align-items-center justify-content-center">
        <!-- <span class="video-watermark dark">{{ personalInfo?personalInfo.userId:'' }}</span>
      <span class="video-watermark light">{{ personalInfo?personalInfo.userId:'' }}</span> -->
        <swiper :options="swiperOption" ref="mySwiper" @slideChange="changeSwiperIndex">
          <swiper-slide class="position-relative wiperSlideWrapper" v-for="(links, k) in linkUrl" :key="k">
            <iframe :src="links" title="description" :id="`iframe_${k}`" scrolling="0"></iframe>
          </swiper-slide>
          <div class="swiper-button-prev" slot="button-prev" v-if="Array.isArray(linkUrl) && linkUrl.length > 1"></div>
          <div class="swiper-button-next" :class="addOpacityClass == true ? 'opacity-class' : ''" slot="button-next" v-if="Array.isArray(linkUrl) && linkUrl.length > 1">
          </div>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>
    <div class="portrait-footer">
      <div class="divider bg-divider"></div>
      <div class="d-flex justify-content-between pdt-19 pdl-16 pdr-16 pdb-19 align-items-center">
        <div class="font-13 t-color-gray9">
          {{
            showLectureList
              ? `${$t("1086")}`
              : `${$t("1045")}: ${nextLessonName}`
          }}
        </div>
        <div class="t-body6 t-color-white" id="list-toggler">
          <i class="material-icons">expand_less</i>
        </div>
      </div>
    </div>

    <div id="video-list" class="bg-dark1">
      <nav class="nav-extended bg-white">
        <div class="nav-wrapper bg-dark1 d-flex justify-content-between pdl-16 pdr-16 pdt-16 pdb-16">
          <div class="t-center w-full">
            <a href="#" class="brand-logo center t-headline8 t-color-title l-spacing6">Lesson list</a>
          </div>

          <span class="right pdr-16 t-color-white" id="listRemove"><i class="material-icons">expand_more</i></span>
        </div>
      </nav>
      <div class="h-full scroll-y">
        <div class="lectures-list pdl-16 pdr-16 pdt-10 pdb-11">
          <lessons-list :lessonsList="lessonsList" :currentProgressionId="currentProgressionId"></lessons-list>
        </div>
      </div>
    </div>
  </body>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
//import Swiper from "https://unpkg.com/swiper/swiper-bundle.esm.browser.min.js";
import learnApi from "@/api/learnApi.js";
import LessonsList from "./LessonsListHtml.vue";
import { htmlTypeMixins } from "../../mixins/htmlType.js";
import TimelineQuizPop from "./TimelineQuizPop.vue";
import TimelineQuizDetail from "./TimelineQuizDetail.vue";
import TimelineResourcePop from "./TimelineResourcePop.vue";
import LikeAndBookmark from "./LikeAndBookmark.vue";
import PopNextLesson from "./PopNextLesson.vue";
import { captureApiError } from "@/utils/sentryApiHandler.js";
import { updateLearnProgression } from "@/utils/learnProgressionUtil.js";

export default {
  data() {
    return {
      linkUrls: [],
      linkUrl: "",
      lessonData: null,
      lessonName: "",
      lessonsList: [],
      slideFiles: [],
      nextLessonName: "",
      urlProgressionId: "",
      currentProgressionId: "",
      rate: 0,
      last: 0,
      recent: 0,
      time: 0,
      countFile: 0,
      currentSlide: 0,
      showLectureList: false,
      staticPageStatus: true,

      // 북마크 좋아요 관려 데이터(like & bookmark data)
      isLiked: false,
      isBookmarked: false,
      likes: false,
      likesCount: 0,
      clipping: false,
      clippingCount: 0,

      isAllPages: false,
      isScroll: false,
      isTimeline: false,
      isExpand: false,
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 50,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          type: "fraction",
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        translate: 0,
        autoHeight: false,
      },
      currentSliderIndex: 0,
      startIndex: 0,
      startTime: 0,
      enablNext: false,
      heartcolor: { color: "#758191" },
      bookMarkColor: { color: "#758191" },
      personalInfo: null,
      addOpacityClass: false
    };
  },
  watch: {
    setSlideNumber() {
      this.mySwiper.slideTo(this.setSlideNumber - 1);
    },
  },
  components: {
    swiper,
    swiperSlide,
    "lessons-list": LessonsList,
  },
  mixins: [htmlTypeMixins],
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  mounted() {
    //this.slideSwiper = this.$refs.mySwiper.swiper
    //let activeIndex = this.$refs.mySwiper.swiper.activeIndex;
    //   console.log('activeIndex=>',activeIndex)
    this.urlProgressionId = this.$route.params.progressionId;

    $(".video").click(function () {
      this.paused ? this.play() : this.pause();
    });
    $(".video-list-item").click(function () {
      $(this).addClass("active").siblings().removeClass("active");
    });
    $("#list-toggler").click(function () {
      $("#video-list").show().addClass("showList");
    });
    $("#listRemove").click(function () {
      $("#video-list").hide().removeClass("showList");
    });
    let params = this.setParams();
    let responseData = null;
    //console.log("params", this.$route.params);

    //차시 컨텐츠 정보 API 호출(get lesson contents data)
    this.$showLoading();
    learnApi
      .learnLessonContents(params)
      .then((response) => {
        responseData = response.data.data;
        this.lessonData = responseData;
        this.lessonName = this.lessonData.lessonName;
        this.rate = this.lessonData.rate;
        this.slideFiles = this.lessonData.html.files;
        this.linkUrl = this.lessonData.html.files;
        this.countFile = this.lessonData.html.count;

        //this.linkUrls = this.lessonData.html.files;
        // this.linkUrl = this.linkUrls.map((url) =>
        //   parseInt(url.split("/").pop().replace(/[^\d]/g, ""))
        // );

        // in case of update url format
        //this.linkUrl = this.linkUrls.map(url => url.split('/').pop())

        // this.linkUrl.sort((a, b) => a - b);
        // console.log("this.linkUrl", this.linkUrl);

        this.last = this.lessonData.last;
        this.recent = this.lessonData.recent;
        this.currentProgressionId = this.lessonData.progressionId;


        this.likes = this.lessonData.likes;

        this.likesCount = this.lessonData.likesCount;
        this.clipping = this.lessonData.clipping;

        this.clippingCount = this.lessonData.clippingCount;

        this.updateProgress();

        this.fetchLectureList();
        this.$hideLoading();

        // 학습창 진입 시 START 화면 없이 바로 컨텐츠 진입 (기존 getSwiperData 로직 유지)
        this.staticPageStatus = false;
        this.$nextTick(() => this.getSwiperData());
      })
      .catch((err) => {
        captureApiError({ err, frontRoute: this.$route, frontData: this.$data });
      });

    learnApi.learnLessonTimelinecontents(params).then((response) => {
      responseData = response.data.data
      // console.log('learnLessonTimelinecontents', responseData)
      this.timelineContents = responseData
    }).catch((err) => {
      captureApiError({ err, frontRoute: this.$route, frontData: this.$data });
    })

    learnApi.getMemberInfo().then((response) => {
      this.personalInfo = response.data.data
    }).catch((err) => {
      captureApiError({ err, frontRoute: this.$route, frontData: this.$data });
    })


  },

  methods: {
    // OnlyOne Html File
    updateProgressWithOneHtml() {

      let params = {
        total: this.countFile,
        current: this.currentSliderIndex + 1,
        learnId: this.$route.params.learnId,
        progressionId: this.$route.params.progressionId,
      };

      let responseData = null;

      if (this.countFile === parseInt(this.currentSliderIndex + 1)) {
        this.addOpacityClass = true
      } else {
        this.addOpacityClass = false
      }

      if (!this.rate && this.urlProgressionId == this.currentProgressionId) {
        //console.log('updateProgressWithOneHtml',this.currentProgressionId)
        updateLearnProgression({ params, vueThis: this })
          .then((response) => {
            if (response) {
              responseData = response.data.data;
              // console.log(responseData)
              this.rate = responseData.rate;
              this.last = responseData.last;
            }
          })
          .catch((err) => {
            captureApiError({ err, frontRoute: this.$route, frontData: this.$data });
          });
      }
    },

    getSwiperData() {
      this.addOpacityClass = true
      let paramss = this.setParams();
      learnApi
        .learnLessonContents(paramss)
        .then((response) => {
          let responseDatas = response.data.data;
          this.lessonData = responseDatas;
          this.countFile = this.lessonData.html.count;
          this.countFile === 1 ? this.updateProgressWithOneHtml() : this.updateProgressWithOneHtml();
        }).catch((err) => {
          captureApiError({ err, frontRoute: this.$route, frontData: this.$data });
        });

      this.staticPageStatus = false;
      this.slideSwiper = this.$refs.mySwiper.swiper;
      this.startIndex = this.recent ? this.recent - 1 : 0;

      if (this.startIndex > 0 && this.startIndex < this.slideFiles.length - 1) {
        this.$confirm({
          title: this.$t("173"), // '학습 중인 강의입니다.',
          content: this.$t("174") + "<br>" + this.$t("175"), //'이전에 학습했던 이력이 있습니다.<br>이어서 학습하시겠습니까?',
          accept: this.$t("177"), //'이어서 보기',
          cancel: this.$t("176"), //'처음부터 보기',
        })
          .then(() => {
            console.log("then");
            this.$refs.mySwiper.swiper.slideTo(this.startIndex);
          })
          .catch(() => {
            console.log("catch");
            this.$refs.mySwiper.swiper.slideTo(0);
          });
      } else {
        console.log("else");
        this.$refs.mySwiper.swiper.slideTo(0);
      }

      // 첫페이지 진도저장 실행(first load save progress)

      if (this.time > 0 && this.startIndex + 1 > this.last) {
        this.runTimer(this.startIndex);
      } else {
        this.enablNext = true;
      }

      this.$refs.mySwiper.swiper.allowSlideNext = this.enablNext;

      if (this.contentsType != "PDF") {
        this.$refs.mySwiper.swiper.on("slideChange", () => {
          let activeIndex = this.$refs.mySwiper.swiper.activeIndex;
          this.runTimer(activeIndex);
          if (this.urlProgressionId == this.currentProgressionId) {
            //console.log('getSwiperData',this.currentProgressionId)
            this.$emit("updateProgress", activeIndex);
          }

        });
      }

      this.$refs.mySwiper.swiper.on("touchStart", () => {
        if (
          this.enablNext === true &&
          this.slideFiles.length - 1 === this.$refs.mySwiper.swiper.activeIndex
        ) {
          if (this.urlProgressionId == this.currentProgressionId) {
            //console.log('touchStart',this.currentProgressionId)
            this.$emit("updateEndedLesson", true);
          }
        } else {
          if (this.urlProgressionId == this.currentProgressionId) {
            //console.log('touchStart=>Else',this.currentProgressionId)
            this.$emit("updateEndedLesson", false);
          }
        }
      });
    },
    runTimer(activeIndex) {
      if (this.last < activeIndex + 1) {
        this.enablNext = false;
        this.startTime = this.time;
        this.setTimer();
      }
    },
    // 슬라이드 타이머 동작(Slide timer action)
    setTimer() {
      this.startTime--;
      if (this.startTime > 0) {
        setTimeout(() => {
          //console.log("this.startTime", this.startTime);

          this.setTimer();
        }, 1000);
      } else {
        this.enablNext = true;
      }
    },

    changeSwiperIndex() {
      //console.log('sfsdfsdf',this.$refs.mySwiper.swiper)
      this.currentSliderIndex = this.$refs.mySwiper.swiper.realIndex;
      if (this.countFile === parseInt(this.currentSliderIndex + 1)) {
        this.addOpacityClass = true
      } else {
        this.addOpacityClass = false
      }
      let params = {
        total: this.countFile,
        current: this.currentSliderIndex + 1,
        learnId: this.$route.params.learnId,
        progressionId: this.$route.params.progressionId,
      };
      if (this.urlProgressionId == this.currentProgressionId) {
        //console.log('changeSwiperIndex',this.currentProgressionId)
        updateLearnProgression({ params, vueThis: this })
          .then((response) => {
            if (response) {
              let responseData = response.data.data;
              this.rate = responseData.rate;
              this.last = responseData.last;
            }
          })
          .catch((err) => {
            captureApiError({ err, frontRoute: this.$route, frontData: this.$data });
          });
      }

    },

    getLinkUrl(links) {
      let url = this.linkUrls.find(
        (str) => parseInt(str.split("/").pop().replace(/[^\d]/g, "")) == links
      );

      // in case of change in format
      //let url = this.linkUrls.find(str => str.split('/').pop() == links)
      return url || null;
    },
    // 진도저장 API 호출(update progress)
    updateProgress() {
      //console.log("currentSliderIndex123", this.$refs.mySwiper.swiper);
      let params = this.setParams();
      let responseData = null;

      if (!this.rate && this.urlProgressionId == this.currentProgressionId) {
        //console.log('updateProgress',this.currentProgressionId)
        updateLearnProgression({ params, vueThis: this })
          .then((response) => {
            if (response) {
              responseData = response.data.data;
              // console.log(responseData)
              this.rate = responseData.rate;
              this.last = responseData.last;
            }
          })
          .catch((err) => {
            captureApiError({ err, frontRoute: this.$route, frontData: this.$data });
          });
      }
    },



    // API 파라미터 설정(set parameter)
    setParams() {
      let params = {
        total: this.countFile,
        current: this.currentSliderIndex,
        learnId: this.$route.params.learnId,
        progressionId: this.$route.params.progressionId,
      };
      return params;
    },
    fetchLectureList() {
      let responseData = null;
      let params = this.setParams();
      //차시 정보
      learnApi
        .learnViewCourses(params)
        .then((response) => {
          // 과정의 차시 정보만 병합(Merging only lesson data from the course)
          _.each(response.data.data, (course) => {
            this.lessonsList = this.lessonsList.concat(course.lessons);
          });

          //console.log('this.lessonsList',this.lessonsList)
          // 다음 차시명 설정(set next lesson)
          let currentLessonIndex = _.findIndex(this.lessonsList, (lesson) => {
            return lesson.progressionId === this.currentProgressionId;
          });


          let nextLessonIndex = this.lessonsList.length > 1 && this.lessonsList.length > currentLessonIndex ? (currentLessonIndex += 1) : -1;

          if (nextLessonIndex) {
            this.nextLesson = this.lessonsList[nextLessonIndex]
            //this.nextLessonName = this.lessonsList[nextLessonIndex].name
            console.log("nextLessonIndex", this.lessonsList[nextLessonIndex]);
            if (nextLessonIndex === -1) {
              this.nextLessonName = this.$t('1999')
            } else {
              if (typeof (this.lessonsList[nextLessonIndex]) != "undefined") {
                this.nextLessonName = this.lessonsList[nextLessonIndex].name
              } else {
                this.nextLessonName = this.$t('1999')
              }

            }
          }
        })
        .catch((err) => {
          captureApiError({ err, frontRoute: this.$route, frontData: this.$data });
        });
    },
    setLikeAndBookParams() {
      let params = {
        learnId: this.$route.params.learnId,
        progressionId: this.$route.params.progressionId,
      };
      return params;
    },
    onLike() {
      let params = this.setLikeAndBookParams();
      let responseData = null;
      if (this.likes) {
        learnApi
          .learnLessonLikesDelete(params)
          .then((response) => {
            responseData = response.data.data;
            //this.heartcolor={'color':'#758191 !important'}
            this.likes = response.data.data;
            this.$emit("updateLikesCount", {
              likes: responseData,
              likesCount: this.likesCount - 1,
            });
          })
          .catch((err) => {
            captureApiError({ err, frontRoute: this.$route, frontData: this.$data });
          });
      } else {
        learnApi
          .learnLessonLikesPost(params)
          .then((response) => {
            //this.heartcolor={'color':'#C30E2F !important'}
            responseData = response.data.data;
            this.likes = response.data.data;
            this.$emit("updateLikesCount", {
              likes: responseData,
              likesCount: this.likesCount + 1,
            });
          })
          .catch((err) => { });
      }
    },

    // 북마크 API 호출(set/cancel bookmark)
    onBookmark() {
      let params = this.setParams();
      let responseData = null;
      if (this.clipping) {
        learnApi
          .learnLessonClippingDelete(params)
          .then((response) => {
            responseData = response.data.data;
            this.clipping = responseData;
            //this.bookMarkColor={'color':'#758191 !important'}
            this.$emit("updateBookmarkCount", {
              clipping: responseData,
              clippingCount: this.clippingCount - 1,
            });
            this.toggleBookmarkIcon();
          })
          .catch((err) => { });
      } else {
        learnApi
          .learnLessonClippingPost(params)
          .then((response) => {
            responseData = response.data.data;
            this.clipping = responseData;
            this.$emit("updateBookmarkCount", {
              clipping: responseData,
              clippingCount: this.clippingCount + 1,
            });
          })
          .catch((err) => { });
      }
    },
    moveQuestion() {
      this.$router.push({
        name: "LessonViewQuestion",
        query: this.$route.query,
      });
    },
    goBacKPreviousPage() {
      this.$router.push({
        name: "LearnView",
        params: { learnId: this.$route.params.learnId },
        query: this.$route.query,
      });
    },
  },
};
</script>

<style scoped src="../../css/html.css"></style>
<style scoped>
.swiper-container {
  width: 100% !important;
}

span.video-watermark {
  position: absolute;
  /* left: 20px; */
  font-size: 12px;
  transform: rotate(-45deg) translate(-50%, -50%);
  opacity: 0.25;
  cursor: none;
  z-index: 999;
}

span.video-watermark.light {
  color: #FFF;
  left: 40%;
  bottom: 50%;
}

span.video-watermark.dark {
  color: #000000;
  bottom: 50%;
  left: 50%;
}

.swiper-pagination {
  visibility: hidden;
}

@media (orientation: landscape) {
  span.video-watermark.light {
    left: 46%;
  }
}

.swiper-button-prev.swiper-button-disabled,
.swiper-button-next.swiper-button-disabled {
  opacity: 0 !important;
}

.opacity-class {
  opacity: 0;
  cursor: auto;
  pointer-events: none;
}

.swiper-button-prev {
  /* background-image: url("/images/backword.svg") !important; */
  left: 24px !important;
}

.swiper-button-next {
  /* background-image: url("/images/forward.svg") !important; */
  right: 24px !important;
}
</style>
